import type { PropsWithChildren, ComponentProps, FunctionComponent } from 'react'; 
import { classes } from '@/util/component-utils';
import type { Optional } from '@/types/types';
import styles from './IconButton.module.css';


interface IconButtonProps extends PropsWithChildren, ComponentProps<"button"> {
    round?: boolean,
    defaults?: boolean,
    padding?: string
};

const IconButton: FunctionComponent<IconButtonProps> = ({
    round,
    defaults,
    padding,
    className,
    children,
    ...buttonProps
}) => {
    const roundClass = round ? styles.round : styles.normal;
    let styleAttr;
    if (padding) {
        styleAttr = {
            padding: padding
        }
    }
    let defaultsClass: Optional<string> = styles.defaults;
    if (!defaults) {
        defaultsClass = undefined;
    }

    return (
        <button style={styleAttr} {...buttonProps} className={classes(styles.button, roundClass, className, defaultsClass)}>
            <div className={styles.inner}>
                { children }
            </div>
        </button>
    )
}

export default IconButton;